export default __webpack_public_path__ + "static/after-4-6c845550d9f99cde27dcb2128f96aa09.jpeg";